
import React from "react";
import { useTranslations } from "use-intl";
import { Invoice, Filters } from "@/types/payments";

interface ResultsSummaryProps {
  sortedInvoices: Invoice[];
  filteredInvoices: Invoice[];
  filters: Filters;
}

const ResultsSummary: React.FC<ResultsSummaryProps> = ({
  sortedInvoices,
  filteredInvoices,
  filters
}) => {
  const t = useTranslations("consultantPayables.table");
  if (sortedInvoices.length === 0) {
    return null;
  }
  
  const isFiltered = 
    (filters.status !== 'all') || 
    !!filters.vendor || 
    !!filters.minAmount || 
    !!filters.maxAmount || 
    (filters.currency !== 'all');

  return (
    <div className="mt-2 text-sm text-muted-foreground">
      {t("showing", { count: sortedInvoices.length })}
      {isFiltered && filteredInvoices.length > sortedInvoices.length &&
        t("filteredFrom", { total: String(filteredInvoices.length) })}
    </div>
  );
};

export default ResultsSummary;
